import { Box, type BoxProps } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { DetailTextField } from '~/components/forms/details';
import {
  SettingDescription,
  SettingInputWrapper,
  SettingLabelWrapper,
  SettingName,
  SettingsBody,
  SettingsData,
  SettingsHead,
} from '~/components/settings';
import { formatDate } from '~/lib/datetime';

interface TimestampsProps extends BoxProps {
  createdAt: string;
  updatedAt: string;
}

export const Timestamps = ({ createdAt, updatedAt, ...boxProps }: TimestampsProps) => {
  const { t } = useTranslation();

  return (
    <Box {...boxProps}>
      <SettingsHead>{t('common.timestamps.section_title')}</SettingsHead>
      <SettingsBody>
        <SettingsData>
          <SettingLabelWrapper>
            <SettingName>{t('common.timestamps.created_at_label')}</SettingName>
            <SettingDescription>{t('common.timestamps.created_at_description')}</SettingDescription>
          </SettingLabelWrapper>
          <SettingInputWrapper>
            <DetailTextField disabled fullWidth value={formatDate(createdAt)} />
          </SettingInputWrapper>
        </SettingsData>
        <SettingsData className="last">
          <SettingLabelWrapper>
            <SettingName>{t('common.timestamps.updated_at_label')}</SettingName>
            <SettingDescription>{t('common.timestamps.updated_at_description')}</SettingDescription>
          </SettingLabelWrapper>
          <SettingInputWrapper>
            <DetailTextField disabled fullWidth value={formatDate(updatedAt)} />
          </SettingInputWrapper>
        </SettingsData>
      </SettingsBody>
    </Box>
  );
};
